import { createElement, Component, createRef } from 'react';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ChrModal = /*#__PURE__*/function (_Component) {
  _inherits(ChrModal, _Component);
  var _super = _createSuper(ChrModal);
  function ChrModal() {
    var _this;
    _classCallCheck(this, ChrModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      fadeTransition: ''
    });
    _defineProperty(_assertThisInitialized(_this), "modalRef", /*#__PURE__*/createRef());
    _defineProperty(_assertThisInitialized(_this), "keyupCallback", function (e) {
      var isEscapeKey = e.key && e.key.substring(0, 3).toLowerCase() === 'esc';
      if (_this.props.closeAction && isEscapeKey) {
        _this.props.closeAction(e);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onModalOverlayClick", function (e) {
      if (e.target === _this.modalRef.current && _this.props.closeAction && !_this.props.keepOpenOnOverlay) {
        _this.props.closeAction(e);
      }
    });
    return _this;
  }
  _createClass(ChrModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        fadeTransition: 'in'
      });
      document.addEventListener('keyup', this.keyupCallback);
      document.body.classList.add('modal-open');
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keyup', this.keyupCallback);
      document.body.classList.remove('modal-open');
    }
  }, {
    key: "getButtonPropsFromActionProps",
    value: function getButtonPropsFromActionProps(action, label) {
      // Angular ensures that an implementation of an output binding is always provided,
      // so we must check both the action and the label.
      var deprecatedModalPropsDefined = typeof action !== 'undefined' && !!label;
      return !deprecatedModalPropsDefined ? null : {
        buttonClicked: action,
        text: label,
        disabled: action === null
      };
    }

    /**
     * If set, gets ButtonProps from 'props.primaryButtonProps'
     * If not set, and the deprecated 'props.primaryAction' and 'props.primaryActionLabel'
     * are set, creates and returns new ButtonProps from these.
    */
  }, {
    key: "primaryButtonProps",
    get: function get() {
      return this.props.primaryButtonProps || this.getButtonPropsFromActionProps(this.props.primaryAction, this.props.primaryActionLabel);
    }

    /**
     * If set, gets ButtonProps from 'props.secondaryButtonProps'
     * If not set, and the deprecated 'props.secondaryAction' and 'props.secondaryActionLabel'
     * are set, creates and returns new ButtonProps from these.
    */
  }, {
    key: "secondaryButtonProps",
    get: function get() {
      return this.props.secondaryButtonProps || this.getButtonPropsFromActionProps(this.props.secondaryAction, this.props.secondaryActionLabel);
    }
  }, {
    key: "render",
    value: function render() {
      return createElement("div", null, createElement("div", {
        className: "modal-backdrop fade in",
        style: {
          display: 'block'
        }
      }), createElement("div", {
        className: "modal fade ".concat(this.state.fadeTransition),
        role: "dialog",
        "aria-labelledby": "modal",
        style: {
          display: 'block'
        },
        onClick: this.onModalOverlayClick,
        ref: this.modalRef
      }, createElement("div", {
        className: "modal-dialog",
        role: "document"
      }, createElement("div", {
        className: "modal-content"
      }, createElement("div", {
        className: "modal-header"
      }, this.props.closeAction ? createElement("button", {
        type: "button",
        className: "close",
        "aria-label": "Close",
        onClick: this.props.closeAction
      }, createElement("span", {
        "aria-hidden": "true",
        className: "ns-icon ns-md ns-close ns-solo"
      })) : null, createElement("h4", {
        className: "modal-title ".concat(this.props.headerClassNames),
        id: "myModalTitle"
      }, this.props.title)), createElement("div", {
        className: "modal-body",
        style: {
          maxHeight: 'calc(100vh - 180px)',
          overflowY: 'auto'
        }
      }, this.props.children), createElement("div", {
        className: "modal-footer"
      }, this.secondaryButtonProps ? createElement("button", {
        type: "button",
        className: "btn btn-default",
        onClick: this.secondaryButtonProps.buttonClicked,
        disabled: this.secondaryButtonProps.disabled
      }, this.secondaryButtonProps.text) : null, this.primaryButtonProps ? createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.primaryButtonProps.buttonClicked,
        disabled: this.primaryButtonProps.disabled
      }, this.primaryButtonProps.text) : null)))));
    }
  }]);
  return ChrModal;
}(Component);

export { ChrModal };
//# sourceMappingURL=index.es.js.map
